import BcodeNFT from "./abis/BcodeNFT";
import BcodeNotarization from "./abis/BcodeNotarization";

export const IPFS_GATEWAY = "https://gateway.pinata.cloud/ipfs";

export const ERROR_TYPE = {
  NOT_INITIALIZE: "SDK not initialized",
  API_KEY_NOT_AUTHENTICATED: "API Key not authenticated",
  CONTRACT_ERROR: "Smart contract error",
  UNABLE_TO_GENERATE_SUB_JWT: "Unable to generate subJWT",
  UNABLE_TO_CHECK_TOKEN: "Unable to check token",
};

export const ERROR_TYPE_V1 = {
  WRONG_CREDENTIALS: {
    type: "WRONG_CREDENTIALS",
    message: "Wrong credentials",
  },
  MISSING_PARAMS: { type: "MISSING_PARAM", message: "Missing parameters" },
  DOCUMENT_NOT_FOUND: {
    type: "DOCUMENT_NOT_FOUND",
    message: "The document you are searching doesn't exist",
  },
  CONTRACT_NOT_FOUND: {
    type: "CONTRACT_NOT_FOUND",
    message: "The contract you are searching doesn't exist",
  },
  ERROR_WHILE_EXECUTING_FUNCTION: {
    type: "ERROR_WHILE_EXECUTING_FUNCTION",
    message: "An error occured during function execution",
  },
};

export const BCODE_NFT_OBJ = {
  abi: BcodeNFT.abi,
  name: "PablockNFT",
  version: "0.2.2",
};

export const BCODE_NOTARIZATION_OBJ = {
  abi: BcodeNotarization.abi,
  name: "PablockNotarization",
  version: "0.1.1",
};

export const NFT_ATTRIBUTES = [
  "text",
  "document",
  "image",
  "warranty_certificate",
  "partner",
  "authenticity_certificate",
];

export const NFT_FUNCTIONALITIES = [
  "restricted_area",
  "poll",
  "shop",
  "product",
  "news",
];
